export const constants = {
  formSelector: "popup__form",
  inputSelector: ".popup__input",
  submitButtonSelector: ".popup__button",
  inactiveButtonClass: "popup__button_disabled",
  inputErrorClass: "popup__input_type_error",
  errorClass: "popup__error_visible",
  cardSection: "elements",
  cardTemplate: "#card-template",
  cardFormPopupSelector: ".create-popup",
  avatarFormPopupSelector: "avatar-popup",
};

export const nameInput = ".profile__info-title";
export const titleInput = ".profile__info-subtitle";
export const avatarInput = ".profile__avatar-image";
export const cardSection = ".elements";
